import React from "react";
import CircleIcon from "mdi-react/CircleOutlineIcon";
import CheckCircleIcon from "mdi-react/CheckCircleOutlineIcon";
import StarIcon from "mdi-react/StarCircleOutlineIcon";
const PropertyCard = ({
  property,
  index,
  isSubject,
  isSelected,
  onClick,
  showSelectIcon,
  compSource,
  buttonText,
  openDetailModal, // optional
  showChangeButton,
  avgDOM,
  disableSelect,
  linkURL
}) => {
  
  
  let dragStartX = 0;
  let dragThreshold = 5;
  
  const handleMouseDown = (e) => {
	dragStartX = e.clientX;
  };
  
  
  const handleClick = (e) => {
	  if (Math.abs(e.clientX - dragStartX) > dragThreshold) {
		// It's a drag, not a click — suppress click
		e.preventDefault();
		e.stopPropagation();
		return;
	  }
	  if (openDetailModal) {
		openDetailModal(property.id);
	  }
	};

  return (
	<div
	  className={`property-card item-${index} ${isSubject ? "subject" : "comp"} ${!isSelected && showSelectIcon ? "not-selected" : ""}`}
	  onClick={openDetailModal ? handleClick : null}
	  onMouseDown={handleMouseDown}
	  style={{ cursor: openDetailModal ? "pointer" : "default" }}
	>
	  <div className="relative">
	  	<div className={`banner ${isSubject ? "subject" : "comp"}`}>
		  {isSubject ? <StarIcon /> : null}
		  {!isSubject && !isSelected && showSelectIcon ? "ALT COMP" : property.tag}
		  {!isSubject ? <span className="small-text">({property.currentStatus})</span>: null}</div>
		<img src={property.img} alt={property.title} className="property-image" />
		{!isSubject && showSelectIcon ? <div
		  className={`property-badge ${isSubject ? "badge-subject" : "badge-comp select-comp"} ${isSelected ? "selected" : "not-selected"}  ${disableSelect && !isSelected ? " disabled" : ""}`}
		  onClick={onClick}
		>
		  {showSelectIcon && (
			<div className="select-check">
			  {isSelected ? (
				<CheckCircleIcon style={{ width: 30, height: 30 }} />
			  ) : (
				<CircleIcon style={{ width: 30, height: 30 }} />
			  )}
			</div>
		  )}
		  {isSubject ? property.tag : buttonText}
		</div> : null}

		{showChangeButton && !isSubject && (
		  <div
			data-comp-key={property.id}
			className="property-badge comp-chg print-hide badge-comp open-comps"
		  >
			<span className="comp-tag">Change Comp</span>
		  </div>
		)}
	  </div>

	  <div className="property-details">
		<div className={`property-title-wrapper property-title-wrapper-${index}`}>
		  <h3 className="property-title editable">{property.title}</h3>
		  <p className="property-location editable">{property.location}</p>
		  
		  {linkURL ? 
			<div
				key={property.id}
				data-key={property.id}
				className="property-detail"
			  >
				<a href={`${linkURL}`} className="comp-link" target="_blank">See Details</a>
			  </div>  
			  
		  :
		  <div
			key={property.id}
			data-key={property.id}
			className="property-detail open-detail print-hide"
		  >
			<span className="comp-link">See Details</span>
		  </div>
	  	  }
		</div>
		
		<div className={`property-info-box property-info-box-${index}`}>
		  <p className="property-info-title editable">{property.type}</p>
		  <p className="property-info-subtext editable">
		  Year Built: {property.yearBuilt}
		  {!isSubject ? <span><br/>Distance: {property.distance}</span>:<span><br/>Distance: --</span>}
		  </p>
		  
		</div>

		<div className={`property-info-box property-info-box-${index}`}>
		  <p className="property-info-title editable">{property.bedsBaths}</p>
		  <p className="property-info-subtext editable">{property.size}</p>
		</div>

		<div className={`property-info-box property-info-box-${index}`}>
		  <p className="property-info-title editable">{property.price}</p>
		  <p className="property-info-subtext editable">
			{property.priceType} {property.date ? `(${property.date})` : ""}
		  </p>
		</div>

		<div className={`property-info-box property-info-box-${index}`}>
		  <p className="property-info-title editable">{property.psf || "N/A"}</p>
		  <p className="property-info-subtext editable">{property.psfType}</p>
		</div>

		{compSource === "activeComps" && (
		  <div className={`property-info-box property-info-box-${index}`}>
			<p className="property-info-title editable">
			  {isSubject ? avgDOM : property.daysOnMarket}
			</p>
			<p className="property-info-subtext editable">{property.daysOnMarketHeading}</p>
		  </div>
		)}
	  </div>
	</div>
  );
};

export default PropertyCard;
